import { FC, PropsWithChildren } from 'react';
import { Element, Resolver } from '@craftjs/core';
import { IEmptyBlock } from './content/EmptyBlock';
import { IContainer } from './containers/Container';
import { IText } from './content/Text';
import { IAttentionText } from './content/AttentionText';
import { IDateInput } from './inputs/DateInput';
import { ITimeInput } from './inputs/TimeInput';
import { ITextInput } from './inputs/TextInput';
import { ICheckBoxInput } from './inputs/CheckBoxInput';
import { ICheckBoxGroupInput } from './inputs/CheckBoxGroupInput';
import { IRadioInput } from './inputs/RadioInput';
import { ISelectInput } from './inputs/SelectInput';
import { IFilesInput } from './inputs/Files';
import { IStepContainer } from './containers/StepContainer';
import { ITabsContainer } from './containers/TabsContainer';
import { IDateRangeInput } from './inputs/DateRangeInput';
import { IBmiInput } from './specials/BmiInput';
import { ICalculatedInput } from './specials/CalculatedBlock';
import { IPatientGroupInput } from './specials/PatientGroupInput';
import { IImageBlock } from './content/ImageBlock';
import { ITagInput } from './inputs/TagInputProps';
import { IFieldGroupContainer } from './containers/FieldGroupContainer';
import { INumberInput } from './inputs/INumberInput';
import { IRecordResultList } from './inputs/RecordResultList';
import { ISliderInput } from './inputs/SliderInput';
import { IBmiInputV2 } from './specials/BmiInputV2';
import { IDateIntervalCalc } from './specials/DateIntervalCalc';

export interface IFormControlsResolver extends Resolver {
  EmptyBlock: IEmptyBlock;
  FieldGroupContainer: IFieldGroupContainer;
  Container: IContainer;
  Text: IText;
  AttentionText: IAttentionText;
  TextInput: ITextInput;
  NumberInput: INumberInput;
  DateInput: IDateInput;
  TimeInput: ITimeInput;
  CheckBoxInput: ICheckBoxInput;
  CheckBoxGroupInput: ICheckBoxGroupInput;
  RadioInput: IRadioInput;
  SelectInput: ISelectInput;
  SliderInput: ISliderInput;
  Files: IFilesInput;
  StepContainer: IStepContainer;
  TabsContainer: ITabsContainer;
  DateRangeInput: IDateRangeInput;
  BmiInput: IBmiInput;
  BmiInputV2: IBmiInputV2;
  CalculatedBlock: ICalculatedInput;
  GroupInput: IPatientGroupInput;
  ImageBlock: IImageBlock;
  TagInput: ITagInput;
  RecordResultList: IRecordResultList;
  DateIntervalCalc: IDateIntervalCalc;
}

export const StubContainer: FC<PropsWithChildren> = ({ children }) => <>{children}</>;

export const StubFieldGroupContainer = () => <Element is={StubContainer} id="drop" />;
export const StubContent = () => <></>;
